module.exports = __webpack_public_path__ + "img/Digrab_Screenshot_1.2012cb0c.jpg";